import { getRequest,postRequest,putRequest,patchRequest,deleteRequest,downloadRequest} from "@/libs/axios";


// 信息协同列表
export function listPage(param) {
    return getRequest( '/yethan/informationCollaboration/listPage', param);
}

// 信息协同编辑
export function infoerMationEdit(param) {
    return putRequest( '/yethan/informationCollaboration', param);
}

// 通过手机号获取用户信息
export function findUser(param) {
    return getRequest( '/yethan/informationCollaboration/findUser', param);
}

// 模糊查找用户信息
export function findUserByKey(param) {
    return getRequest( '/yethan/informationCollaboration/findUserKey', param);
}

// 通过手机号获取用户信息
export function info(infoId) {
    return getRequest( '/yethan/informationCollaboration/info/'+infoId, {});
}

// 通过手机号获取用户信息
export function removeUser(infoId, memberId) {
    return deleteRequest( '/yethan/informationCollaboration/removeUser/'+infoId+"/"+memberId, {});
}

// 删除上传文件
export function removeFile(infoId, fileId) {
    return deleteRequest( '/yethan/informationCollaboration/removeFile/'+infoId+"/"+fileId, {});
}

// 删除通知
export function delInformation(params) {
    return postRequest( '/yethan/informationCollaboration/delete', params);
}

// 发送成员
export function memberList(params) {
    return getRequest( '/yethan/informationCollaborationMember/list', params);
}

// 下载日志
export function logList(params) {
    return getRequest( '/yethan/informationCollaborationLog/list', params);
}
// 写入下载日志
export function logAdd(params) {
    return putRequest( '/yethan/informationCollaborationLog/add', params);
}

// 转发
export function forward(params) {
    return putRequest( '/yethan/informationCollaboration/forward', params);
}
//
export function notice(params) {
    return putRequest( '/yethan/informationCollaboration/notice', params);
}

export function informationApplyPersonal(params) {
    return getRequest( '/yethan/information/apply/personal', params);
}
export function informationApplyList(params) {
    return getRequest( '/yethan/information/apply/list', params);
}
export function editInformationApply(params) {
    return putRequest( '/yethan/information/apply', params);
}

export function deleteInformationApply(applyId) {
    return deleteRequest( '/yethan/information/apply/'+applyId);
}

export function informationApplyDetail(applyId) {
    return getRequest( '/yethan/information/apply/detail', {applyId: applyId});
}

export function informationApplyAddCheck(params) {
    return postRequest( '/yethan/information/apply/addCheck', params);
}

export function informationApplyDelCheck(checkId) {
    return deleteRequest( '/yethan/information/apply/delCheck/'+checkId);
}

export function informationApplyCheck(params) {
    return putRequest( '/yethan/information/apply/check', params);
}

export function submitFile(params) {
    return postRequest( '/yethan/information/apply/submitFile', params);
}

export function slrRefuce(params) {
    return postRequest( '/yethan/information/apply/slrRefuce', params);
}